__turbopack_context__.v({
  "button": "cookie-module__8o4u7W__button",
  "buttonDark": "cookie-module__8o4u7W__buttonDark",
  "container": "cookie-module__8o4u7W__container",
  "containerDark": "cookie-module__8o4u7W__containerDark",
  "link": "cookie-module__8o4u7W__link",
  "linkContainer": "cookie-module__8o4u7W__linkContainer",
  "linkDark": "cookie-module__8o4u7W__linkDark",
  "textDark": "cookie-module__8o4u7W__textDark",
});
